import React from "react";
import PrivacyPolicyBD from "./breadcrumb/PrivacyPolicyBD";
import { Link } from "react-router-dom";
 

function PrivacyPolicy() {
  return (
    <div className="index-one">
      <main>
        <PrivacyPolicyBD />
        <section className="privacy-policy-section tmp-section-gap">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="inner">
                  <div className="section-head text-align-left">
                    <h2 className="section-title ">Privacy Policy</h2>
                  </div>
                  <p className="description">
                    Welcome to Vaishnav To Vaishnav Business Organization. Your privacy is important to us. This Privacy Policy outlines how we collect, use, and protect your personal information when you visit our website <Link to="/">https://v2vbn.org</Link>.
                  </p>

                  <div className="policy-section">
                    <h3 className="title">Information We Collect</h3>
                    <p className="description">We may collect the following personal information from our users:</p>
                    <ul className="policy-list">
                      <li>Full Name</li>
                      <li>Mobile Number</li>
                      <li>Email Address</li>
                      <li>Residential or Business Address</li>
                      <li>GST Number</li>
                    </ul>
                  </div>

                  <div className="policy-section">
                    <h3 className="title">How We Use Your Information</h3>
                    <p className="description">We collect and use your personal information for the following purposes:</p>
                    <ul className="policy-list">
                      <li>To provide and manage our services.</li>
                      <li>To communicate with you regarding inquiries, services, or updates.</li>
                      <li>To process transactions and maintain records.</li>
                      <li>To comply with legal and regulatory requirements.</li>
                    </ul>
                  </div>

                  <div className="policy-section">
                    <h3 className="title">Data Protection & Security</h3>
                    <p className="description">
                      We prioritize the security of your personal information and take appropriate measures to prevent unauthorized access, misuse, or disclosure. However, while we strive to protect your data, no method of transmission over the internet is 100% secure.
                    </p>
                  </div>

                  <div className="policy-section">
                    <h3 className="title">Sharing of Information</h3>
                    <p className="description">We do not sell, trade, or rent your personal information to third parties. Your data may be shared only in the following cases:</p>
                    <ul className="policy-list">
                      <li>When required by law or legal process.</li>
                      <li>To comply with governmental or regulatory requests.</li>
                      <li>With trusted service providers who assist us in business operations (under strict confidentiality agreements).</li>
                    </ul>
                  </div>

                  <div className="policy-section">
                    <h3 className="title">Cookies & Tracking Technologies</h3>
                    <p className="description">
                      Our website may use cookies and similar tracking technologies to enhance user experience and analyze website traffic. You may choose to disable cookies in your browser settings; however, this may affect your experience on our website.
                    </p>
                  </div>

                  <div className="policy-section">
                    <h3 className="title">Your Rights & Choices</h3>
                    <p className="description">You have the right to:</p>
                    <ul className="policy-list">
                      <li>Request access to the personal data we hold about you.</li>
                      <li>Request corrections or updates to your information.</li>
                      <li>Request deletion of your personal information (subject to legal obligations).</li>
                      <li>Opt-out of receiving promotional communications from us.</li>
                    </ul>
                  </div>

                  <div className="policy-section">
                    <h3 className="title">Third-Party Links</h3>
                    <p className="description">
                      Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of such external sites.
                    </p>
                  </div>

                  <div className="policy-section">
                    <h3 className="title">Updates to This Policy</h3>
                    <p className="description">
                      We may update this Privacy Policy periodically to reflect changes in our practices. We encourage you to review this page regularly for updates.
                    </p>
                  </div>

                  <div className="policy-section">
                    <h3 className="title">Contact Us</h3>
                    <p className="description">
                      If you have any questions or concerns about this Privacy Policy, you can contact us at:
                    </p>
                    <ul className="policy-list">
                      <li>📧 Email: <Link to="mailto:admin@v2vbn.org" style={{ 
                        color:"#333"
                      }}>admin@v2vbn.org</Link> </li>
                      <li>🌐 Website: <Link to="/" style={{ 
                        color:"#333"
                      }}>https://v2vbn.org</Link></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default PrivacyPolicy;